module.exports = __webpack_public_path__ + "static/SATMAN-997162b91895994bdc6b43f78e932616.png";